import React from "react";

// Style
import "../../style/Terms";
import {TermsWrapper, TermContent} from "../../style/Terms";

// Images
import logo from "../../images/ic_logo.svg";

const index = () => {
    return (
        <TermsWrapper>
            <a href="/">
                <img src={logo} alt={logo}/>
            </a>
            <TermContent>
                <h1>Smrt Stats Terms of Service</h1>
                <h3>
                    Welcome to Smrt Stats. These Terms of Service apply to the Smrt Stats website located at
                    www.smrtstats.com, its main domain and all subdomains, and all associated applications and services
                    owned by Smrt Football Limited and its affiliates (collectively, the "Smrt Stats Platform"). Smrt
                    Football Limited ("Smrt Stats", "we", "our", or "us") provides the Smrt Stats Platform to you
                    subject to the following terms of use ("Terms"). By visiting the Smrt Stats Platform, you accept
                    these Terms. Please read them carefully.
                </h3>

                <h2>1. PRIVACY</h2>
                <p>
                    Please review Smrt Stats' Privacy Policy, which also governs your visit to the Smrt Stats Platform,
                    to understand Smrt Stats' practices with respect to your personal information.
                </p>

                <h2>2. ELECTRONIC COMMUNICATIONS</h2>
                <p>
                    When you visit the Smrt Stats Platform or send emails, feedback, or messages to Smrt Stats, you are
                    communicating with Smrt Stats electronically. You consent to receive communications from Smrt Stats
                    electronically. Smrt Stats will communicate with you by email or by posting notices on the Smrt
                    Stats Platform. You agree that all agreements, notices, disclosures, and other communications that
                    we provide to you electronically satisfy any legal requirement that such communications be in
                    writing. Any feedback you provide will be deemed non-confidential. Smrt Stats will be free to use
                    such feedback on an unrestricted basis.
                </p>

                <h2>3. SMRT STATS INTELLECTUAL PROPERTY</h2>
                <p>
                    The Smrt Stats Platform and all content included on the Platform, such as text, graphics, logos,
                    button icons, images, video clips, statistical data compilations, and software, (together, "Smrt
                    Stats Intellectual Property") are the property of Smrt Stats or its content providers and is
                    protected by Irish, European Union and international copyright, trademark, patent, trade secret and
                    other intellectual property laws. Smrt Stats, the Smrt Stats logo, and all related names, logos,
                    product and service names, designs, and slogans are trademarks of Smrt Stats, registered under the
                    Irish Register of Trademarks (Trade Mark No. 2023/01150) and protected under European Union and
                    international copyright, trademark, patent, trade secret and other intellectual property laws, and
                    may not be used without Smrt Stats' prior written permission.
                </p>

                <h2>4. LICENSE AND PLATFORM ACCESS</h2>
                <h3>4.1. Limited License</h3>
                <p>
                    Smrt Stats grants you a limited license to access and make personal use of the Smrt Stats Platform
                    and not to download (other than page caching) or modify it, or any portion of it, except with
                    express written consent of Smrt Stats. This license does not include any resale or commercial use of
                    the Smrt Stats Platform or its contents; any derivative use of the Platform or its contents; any
                    downloading or copying of account information; or any use of data mining, robots, or similar data
                    gathering and extraction tools.
                </p>

                <h3>4.2. Prohibited Uses</h3>
                <p>
                    The Smrt Stats Platform or any portion of the Platform may not be reproduced, duplicated, copied,
                    sold, resold, visited, or otherwise exploited for any commercial purpose without express written
                    consent of Smrt Stats. You may not frame or utilize framing techniques to enclose any trademark,
                    logo, or other proprietary information of Smrt Stats without express written consent. You may not
                    use any meta tags or any other "hidden text" utilizing Smrt Stats' name or trademarks without
                    express written consent.
                </p>

                <h3>4.3. Platform Availability</h3>
                <p>
                    Smrt Stats reserves the right to withdraw or amend the Smrt Stats Platform, and any service or
                    material we provide on the Platform, in Smrt Stats' sole discretion without notice. Smrt Stats will
                    not be liable if for any reason all or any part of the Platform is unavailable at any time or for
                    any period.
                </p>

                <h3>4.4. Termination of Rights</h3>
                <p>
                    If you breach these Terms, your right to use the Smrt Stats Platform will stop immediately and you
                    must, at Smrt Stats' option, return or destroy any copies of the materials you have made. No right,
                    title, or interest in or to the Platform or any content on the Platform is transferred to you, and
                    all rights not expressly granted are reserved by Smrt Stats.
                </p>

                <h2>5. ACCEPTABLE USE POLICY</h2>
                <p>
                    By accessing the Smrt Stats Platform, you agree to:
                    <br/>• Use the Platform only for lawful purposes
                    <br/>• Not attempt to gain unauthorized access to any systems or data
                    <br/>• Not interfere with or disrupt the Platform's operation
                    <br/>• Not use the Platform to transmit harmful, offensive, or illegal content
                    <br/>• Not violate any applicable laws or regulations
                    <br/>• Respect the intellectual property rights of Smrt Stats and third parties
                </p>

                <h2>6. STATISTICAL DATA AND VIDEO CONTENT</h2>
                <h3>6.1. Statistical Information</h3>
                <p>
                    Smrt Stats provides football statistical information through our web portal, API service, and XML
                    downloads. This data is provided for informational purposes and we make no warranties regarding its
                    accuracy or completeness.
                </p>

                <h3>6.2. Video Content</h3>
                <p>
                    Smrt Stats may provide video recordings to complement statistical data. Video content is licensed to
                    you for viewing purposes only and may not be downloaded, redistributed, or used for commercial
                    purposes without express written permission.
                </p>

                <h3>6.3. API Usage</h3>
                <p>
                    If you access our API service, you agree to use it in accordance with our API documentation and rate
                    limits. Abuse of the API service may result in suspension of access.
                </p>

                <h2>7. USER ACCOUNTS</h2>
                <h3>7.1. Account Creation</h3>
                <p>
                    To access certain features of the Smrt Stats Platform, you must request the creation of an account.
                    You are responsible for maintaining the confidentiality of your account credentials and for all
                    activities that occur under your account.
                </p>

                <h3>7.2. Account Information</h3>
                <p>
                    You agree to provide accurate and complete information when creating your account and to update this
                    information as necessary to keep it current.
                </p>

                <h2>8. DISCLAIMER OF WARRANTIES AND LIMITATION OF LIABILITY</h2>
                <p>
                    THE SMRT STATS PLATFORM AND ALL INFORMATION, CONTENT, MATERIALS, AND SERVICES INCLUDED ON OR
                    OTHERWISE MADE AVAILABLE TO YOU THROUGH THE PLATFORM ARE PROVIDED BY SMRT STATS ON AN "AS IS" AND
                    "AS AVAILABLE" BASIS. SMRT STATS MAKES NO REPRESENTATIONS OR WARRANTIES OF ANY KIND, EXPRESS OR
                    IMPLIED, AS TO THE OPERATION OF THE PLATFORM OR THE INFORMATION, CONTENT, MATERIALS, OR SERVICES
                    INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH THE PLATFORM.
                </p>
                <p>
                    TO THE FULLEST EXTENT PERMISSIBLE BY APPLICABLE LAW, SMRT STATS DISCLAIMS ALL WARRANTIES, EXPRESS OR
                    IMPLIED, INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY, NON-INFRINGEMENT AND
                    FITNESS FOR A PARTICULAR PURPOSE.
                </p>
                <p>
                    SMRT STATS WILL NOT BE LIABLE FOR ANY DAMAGES OF ANY KIND ARISING FROM THE USE OF THE PLATFORM OR
                    FROM ANY INFORMATION, CONTENT, MATERIALS, OR SERVICES INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU
                    THROUGH THE PLATFORM, INCLUDING, BUT NOT LIMITED TO DIRECT, INDIRECT, INCIDENTAL, PUNITIVE, AND
                    CONSEQUENTIAL DAMAGES.
                </p>
                <p>
                    For information about how we collect, use, and protect your personal data in compliance with GDPR
                    and other data protection regulations, please refer to our <a href="/privacy">Privacy Policy</a>.
                </p>

                <h2>9. APPLICABLE LAW</h2>
                <p>
                    By visiting the Smrt Stats Platform, you agree that the laws of Ireland, without regard to
                    principles of conflict of laws, will govern these Terms and any dispute of any sort that may arise
                    between you and Smrt Stats.
                </p>

                <h2>10. DISPUTES</h2>
                <p>
                    Any dispute relating in any way to your visit to the Smrt Stats Platform or to services provided by
                    Smrt Stats shall be adjudicated exclusively in the courts of Ireland, and each party agrees not to
                    contest the jurisdiction of these courts.
                </p>

                <h2>11. MODIFICATION, SEVERABILITY, WAIVER, ASSIGNMENT, AND ENTIRE AGREEMENT</h2>
                <h3>11.1. Modifications</h3>
                <p>
                    Smrt Stats reserves the right to make changes to the Smrt Stats Platform, policies, and these Terms
                    at any time. By continuing to use or access the Platform after these Terms have changed, you
                    indicate your agreement to the revised Terms.
                </p>

                <h3>11.2. Severability</h3>
                <p>
                    Should any provision of these Terms be found unenforceable, wherever possible this will not affect
                    any other provision, and each will remain in full force and effect.
                </p>

                <h3>11.3. Assignment</h3>
                <p>
                    Smrt Stats may assign, transfer, or delegate these Terms or any right or obligation hereunder in its
                    sole discretion. You may not assign, transfer, or delegate these Terms without Smrt Stats' prior
                    written consent.
                </p>

                <h3>11.4. Entire Agreement</h3>
                <p>
                    These Terms, Smrt Stats' Privacy Policy, and any other agreement between you and Smrt Stats
                    constitute the sole and entire agreement between you and Smrt Stats regarding the Platform and
                    supersede all prior and contemporaneous understandings, agreements, representations, and warranties
                    regarding the Platform.
                </p>

                <h2>12. OPERATOR</h2>
                <p>
                    This website is operated by Smrt Football Limited, with a business address of 13 Charlotte,
                    Honeypark., Dun Laoghaire, Co. Dublin, Ireland A96YF6A. Company Number: 739570.
                </p>
                <p>
                    For questions or concerns regarding these Terms, please contact us at <a
                    href="mailto:contact@smrtstats.com">contact@smrtstats.com</a>.
                </p>
                <p>
                    Last Updated: 27.05.2025
                </p>
            </TermContent>
        </TermsWrapper>
    );
};

export default index;
